<script lang="ts" setup>
import { LoaderOverlay } from '@shared/ui/loaders'

defineOptions({
  name: 'SkeletonProgressReports',
})

</script>

<template>
  <div class="progress-reports skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="./SkeletonProgressReports.scss" />
